import { useCallback } from "react";

import type * as ModelType from "@/components/features/items/discount/list/model/type";

import { multiRowsDataConverter, ordinaryRowsDataConverter } from "./converter";
import { longTermStayRowsDataConverter } from "./converter/long-term-stay";

import type { RowData } from "../../discount-table";

export type Ordinary = ModelType.QueryData["ordinary"];
export type LongTermStay = ModelType.QueryData["longTerm"];
export type Multi = ModelType.QueryData["multi"];

type OrdinaryCase = {
	type: "ordinary";
	ordinaryList: Ordinary;
};

type LongTermStayCase = {
	type: "longTermStay";
	longTermStayList: LongTermStay;
};

type MultiCase = {
	type: "multi";
	ordinaryAndLongTermStayDiscountIdWithNames: Array<{ id: string; name: string }>;
	multiList: Multi;
};

type Props = OrdinaryCase | LongTermStayCase | MultiCase;

export const useDiscountRowsData = () => {
	/**
	 * Ordinary | LongTermStay | Multi のデータから行データを生成する
	 */
	const onGenerateRowsData = useCallback((props: Props): Array<RowData> => {
		if (props.type === "ordinary") {
			return ordinaryRowsDataConverter(props.ordinaryList);
		} else if (props.type === "longTermStay") {
			return longTermStayRowsDataConverter(props.longTermStayList);
		} else {
			return multiRowsDataConverter(props.multiList, props.ordinaryAndLongTermStayDiscountIdWithNames);
		}
	}, []);

	return {
		onGenerateRowsData,
	};
};
